import Controller from '@ember/controller';

export default class RoombaSettingsPermissionsController extends Controller {}
